<div *ngIf="!(indexHistoricalChartSignal())"
  class="fixed inset-0 bg-white opacity-50 flex items-center justify-center z-50">
  <p-progressSpinner styleClass="w-16 h-16" strokeWidth="4" animationDuration=".5s"></p-progressSpinner>
</div>
<div *ngIf="indexHistoricalChartSignal() && indexSubProductInfo()?.HistoricalData"
  class="rounded-md mt-8 w-full bg-gray-100 flex justify-center">
  <div *ngIf="indexHeaderInfo() as ih" class="py-6 w-[80vw]">
    <div class="flex justify-between items-center  py-10 bg-gray-100 ">
      <p class="text-lg font-bold text-gray-800 border-l-4 border-green-600 pl-2 mb-0">Performance Chart</p>
      <div class="flex items-center gap-3">
        <label for="timeFrames" class="font-semibold text-sm text-gray-900">Time Frame</label>
        <div class="border border-gray-300">
          <p-dropdown id="timeFrames" [options]="timeFrames" [(ngModel)]="selectedTimeFrame"
            (onChange)="onTimeFrameChange($event)" optionLabel="label"
            class="w-48 text-sm border border-gray-300 rounded-md shadow-sm pl-2"
            panelStyleClass="custom-dropdown-panel" placeholder="Since Start Date">

          </p-dropdown>
        </div>
      </div>
    </div>
    <div class="text-sm text-gray-800 font-medium mb-2 flex items-center gap-1  mb-5">
      <span class="text-yellow-500">&#9889;</span>
      <span>{{ih.marketingName}}</span>
    </div>
    <div class="  w-full  pb-4 flex justify-center">
      <p-chart type="line" [data]="performanceChartData" [options]="chartOptions()"
        class="w-[100%] max-w-14xl bg-white"></p-chart>
    </div>
    <div class="mt-6 text-xs text-gray-500 pb-4 ">
      <p>Performance shown is net of replication costs and fees.</p>
      <p class="mt-1">Hypothetical Past Performance Data (‘PPD’)</p>
    </div>
  </div>
</div>